export default __webpack_public_path__ + "static/partner-content-27a41296eb3fa27ff81e9861e08c7fe8.png";